import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {UserStorageService} from '@services/local-storage/user-storage/user-storage.service';
import {roleHome, roleOpens} from '@core/data/role-pages';

// A page that is not for the user's role (typed by hand, an old link, the "/dashboard" after login) leads to the
// role's own start page instead of opening empty or with errors
@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivateChild {
  private userStorageService = inject(UserStorageService);
  private router = inject(Router);

  async canActivateChild(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const user = await this.userStorageService.getUserStorage();
    const role = user?.roles?.id;
    if (!user || roleOpens(role, state.url)) {
      return true;
    }
    return this.router.parseUrl(roleHome(role));
  }
}
